export default "__VITE_ASSET__95e850b0__"